import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { PIPELINE_QUERY_KEYS } from '@/api/pipelines/queries';

import type { PipelineDragMove, PipelineRouteKey } from '../types';

type MovePipelineCard = (_payload: { cardId: string; targetStage: string }) => Promise<unknown>;

type PipelineCardMoveOptions = {
  pipeline: PipelineRouteKey;
  movePipelineCard: MovePipelineCard;
};

export const usePipelineCardMove = ({ pipeline, movePipelineCard }: PipelineCardMoveOptions) => {
  const queryClient = useQueryClient();

  return useCallback(
    async (move: PipelineDragMove) => {
      await movePipelineCard({
        cardId: move.cardId,
        targetStage: move.targetStage,
      });

      void queryClient.invalidateQueries({
        queryKey: [PIPELINE_QUERY_KEYS.board, pipeline],
      });
      void queryClient.invalidateQueries({
        queryKey: [PIPELINE_QUERY_KEYS.cardDetail, pipeline, move.cardId],
      });
    },
    [movePipelineCard, pipeline, queryClient],
  );
};
